import type { TFunction } from "i18next";

export const relativeAdvantagesLabel = (t: TFunction, designContest: boolean): string =>
  designContest
    ? t("The winning entry's characteristics and relative advantages")
    : t("The winning tender's characteristics and relative advantages");
